<div id="idMenuArbolWrapper" *ngIf="!answerDisplayed && !cargandoDatos" style="height: 100%;">
  <button *ngIf="this.currentFather && this.currentFather.id!=='ROOT'"
    style="text-align: left; width: 100%; background-color: #013B82;box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0),0 2px 2px 0 rgba(0, 0, 0, 0),0 1px 5px 0 rgba(0, 0, 0, 0);"
    mat-raised-button color="primary" class="boton-volver difuminador" (click)="loadParent()">
    <svg class="arrow" version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 32"
      style="enable-background:new 0 0 32 32;" xml:space="preserve">
      <rect id="_Transparent_Rectangle_" />
      <polygon points="18,6 16.6,7.4 24.1,15 3,15 3,17 24.1,17 16.6,24.6 18,26 28,16 " />
    </svg>
    {{(!(this.currentGrandparent.name==="Raiz")?"Volver a
    "+this.currentGrandparent.name:"Elegir otro tema de
    consulta")}}
  </button>
  <div id="idMenuArbolInnerContent" class="card-body bg-white menu-inner-content"
    style="border-radius: 4px 4px 0px 0px;">

    <div class="card-body-content" *ngIf="habilitado">
      <div id="divNodoPadreSelected" [attr.data-valor]="miValorVariablePadre" *ngIf="mostrarDiv"></div>
      <div id="divNodoSelected" [attr.data-valor]="miValorVariable" *ngIf="mostrarDiv"></div>
      <h4 class="titulo-principal mt-2 mb-4 f-22">{{this.currentFather.name!=="Raiz"?this.currentFather.name :"¿Cómo
        puedo ayudarte?"}}</h4>
      <h5 *ngIf="currentFAQ.length>0" class="font-weight-normal f-18">{{this.currentFather.name!=="Raiz"?"Lo más
        consultado" :"Lo más consultado"}}</h5>
      <ul class="list-pretty pl-4 mt-3">
        <li *ngFor="let faqNode of currentFAQ">
          <app-nodo-arbol [node]="faqNode" (displayAnswerEmitter)="displayAnswer($event)"></app-nodo-arbol>
        </li>
      </ul>
      <h5 class="font-weight-normal f-18">{{this.currentFather.name!=="Raiz"?null:"Elegir un tema para consultar:"}}
      </h5>
      <h5 *ngIf="this.currentFather.name!=='Raiz' && currentFAQ.length>0" class="font-weight-normal f-18">{{"Tema sobre
        «" + this.currentFather.name + "»:"}}</h5>

      <ul class="list-pretty pl-4 mt-3 mb-0">
        <li *ngFor="let node of displayedNodes">
          <app-nodo-arbol [ctx]="ctx" [node]="node" [cantidadNodos]="cantidadNodos"
            [numberOfSiblingsArr]="numberOfSiblingsArr" [numberOfSiblingsArrCreation]="numberOfSiblingsArrCreation"
            (displayAnswerEmitter)="displayAnswer($event)" (nodeEmitter)="seleccionarNodo($event)"
            (renderMenuArbolEmitter)="emitRenderMenuArbol($event)">
          </app-nodo-arbol>
        </li>
      </ul>
      <br />

    </div>
    <div class="card-body-content" *ngIf="!habilitado">
      <h4 class="titulo-principal mt-2 mb-4 f-22">No se posible visualizar el contenido del presente menú ya que se
        encuentra deshabilitado.</h4>
      <br />
    </div>
  </div>



  <!-- seccion blanca placeholder que se despliega en lugar del link al formulario-->
  <div id="id_footer-placeholder" *ngIf="this.currentFather.name==='Raiz'" class="card-body bg-white place-holder-box ">
  </div>

  <div id="id_goto_form" *ngIf="this.currentFather.name!=='Raiz' && this.displayFormEmpresa && this.displayForm"
    class="card-body bg-white" style="height: 40px;font-family: 'Roboto', sans-serif; border-radius: 0px 0px 4px 4px;">
    <p>
      Si aún tienes dudas, envía tu consulta
      <span class="link" (click)="cargarConsulta()">{{ "aquí." }}</span>
    </p>
  </div>
  <div id="id_goto_inicio" *ngIf="this.currentFather.name!=='Raiz'" id="footer" class="card-footer border-0 text-center"
    (click)="returnToStart()">
    <a class="text-white f-13">Volver al inicio</a>
  </div>

</div>

<div *ngIf="answerDisplayed">

  <button mat-raised-button
    style=" text-align: left; width: 100%; background-color: #013B82;box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0),0 2px 2px 0 rgba(0, 0, 0, 0),0 1px 5px 0 rgba(0, 0, 0, 0);"
    color="primary" class="boton-volver difuminador" (click)="clearAnswerDisplayed()">

    <svg class="arrow" version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 32"
      style="enable-background:new 0 0 32 32;" xml:space="preserve">
      <rect id="_Transparent_Rectangle_" />
      <polygon points="18,6 16.6,7.4 24.1,15 3,15 3,17 24.1,17 16.6,24.6 18,26 28,16 " />
    </svg>

    {{this.currentFather.name != "Raíz" ? "Volver a "+ this.currentFather.name : "Elegir otro tema de consulta"}}

  </button>
  <div class="card-body bg-white response-box" style="border-radius: 4px 4px 0px 0px;">
    <div id="divNodoPadreSelected" [attr.data-valor]="miValorVariablePadre" *ngIf="mostrarDiv"></div>
    <div id="divNodoSelected" [attr.data-valor]="miValorVariable" *ngIf="mostrarDiv"></div>
    <div class="card-body-content-response">
      <h4 class="titulo-principal mt-2 mb-4 f-22">{{ answerNode.name }}</h4>
      <div [innerHtml]="answerNode.answer"></div>
    </div>
  </div>
  <div class="card-body bg-white" *ngIf="this.displayFormEmpresa && this.displayForm"
    style="height: 40px;font-family: 'Roboto', sans-serif; border-radius: 0px 0px 4px 4px;">
    <p>
      Si aún tienes dudas, envía tu consulta
      <span class="link" (click)="cargarConsulta()">{{ "aquí." }}</span>
    </p>
  </div>
  <div id="footer" class="card-footer border-0 text-center" (click)="returnToStart()">
    <a class="text-white f-13">Volver al inicio</a>
  </div>
</div>


<div class="spinner-overlay" *ngIf="cargandoDatos">
  <div class="spinner-center">
    <mat-spinner diameter="80" color="primary"></mat-spinner>
    <label class="input-label" *ngIf="cargandoDatos">&nbsp; Cargando datos...</label>
  </div>
</div>